import React, { useState, useEffect, useRef } from "react";
import { db } from "../../../firebase";
import ApiService from "../../../core/services/ApiService";
import { serverTimestamp } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { encode } from "base-64";
import moment from "moment/moment";
import Search from "../../../assets/user/images/search1.svg";
import uploadImage from "../../../assets/admin/images/uploadImage.svg";
import locationImage from "../../../assets/admin/images/Google_Map.svg";
import AttachImg from "../../../assets/user/images/attachemnt.svg";
import StarImg from "../../../assets/user/images/star.svg";
import DollarImg from "../../../assets/user/images/dollar-circle.svg";
import BreifImg from "../../../assets/user/images/briefcase.svg";
import HouseImg from "../../../assets/user/images/house.svg";
import HandImg from "../../../assets/user/images/Handshake.svg";
import StarWhImg from "../../../assets/user/images/starwh.svg";
import SearchImg from "../../../assets/user/images/search-normal.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import { api } from "../../../utlis/user/api.utlis";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import RepeatImg from "../../../assets/user/images/Repeat.svg";
import Loader from "../../../layouts/loader/Loader";
import { routes } from "../../../utlis/user/routes.utlis";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import toast from "react-hot-toast";
import { weekDays } from "../../../utlis/common.utlis";

const Page = () => {
  const bottomRef = useRef(null);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  let userId = JSON.parse(localStorage.getItem("careexchange")).userId;
  const [ratingModal, setRatingModal] = useState({
    status: false,
    id: null,
    provider_id: null,
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(0);
  const [providers, setProvider] = useState([]);
  const [myDetails, setMyDetails] = useState();
  const [details, setDetails] = useState();
  const [bookingStatus, setBookingStatus] = useState({
    open: false,
    status: null,
    id: null,
    providerUserId: null,
  });
  const [list, setList] = useState([]);
  const [sendInfo, setSenderData] = useState({
    userId: null,
    senderId: null,
    name: "",
    image:
      "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava6-bg.webp",
  });
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const [messagesData, setMessagesData] = useState([]);
  const [shareList, setShareList] = useState([]);
  const [share, setShare] = useState({
    status: false,
  });

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const initialValuesRating = {
    rating: "",
    review: "",
  };

  const validationSchemaRating = Yup.object().shape({
    rating: Yup.string().required("Rating is required!"),
    review: Yup.string().required("Review message is required!"),
  });

  const getProviders = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all providers list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setProvider(response.data.data.ProviderList);
    } else setProvider([]);
    setLoading(false);
  };

  const bookingList = async (api) => {
    const res = await ApiService.getAPIWithAccessToken(api);
    // console.log(res.data);
    if (
      res.data.status &&
      res.data.statusCode === 200 &&
      res.data?.data?.bookingList
    ) {
      setList(res.data?.data?.bookingList);
    } else setList([]);
  };

  const bookingRequest = async (id, status, providerUserId) => {
    setLoading(true);
    let form = JSON.stringify({
      status: status,
      userid: providerUserId,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.serviceRequest + id,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      bookingList(api.bookingList + `?providerid=${sendInfo.senderId}`);
      setBookingStatus({
        open: false,
        status: null,
        id: null,
        providerUserId: null,
      });
      toast.success(response.data.message);
    } else toast.error(response.data.message);
    setLoading(false);
  };

  const createGroup = async (userid, id, name, image, exist = false) => {
    setSenderData({ userId: userid, senderId: id, name: name, image: image });
    setMessagesData([]);
    setFile(null);
    setStatus(0);
    const response = await ApiService.getAPIWithAccessToken(
      api.providerDetail + `${id}`
    );
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data);
    } else setDetails();
    bookingList(api.bookingList + `?providerid=${id}`);
  };

  const convertTime = (time) => {
    if (time && time.seconds && time.nanoseconds) {
      const fireBaseTime = new Date(
        time.seconds * 1000 + time.nanoseconds / 1000000
      );
      return fireBaseTime.toString();
    } else return new Date();
  };

  const handleKey = (e) => {
    e.code === "Enter" && sendMessage();
  };

  const sendMessage = async () => {
    if (message == "" && !(file != null && file != undefined && file != "")) {
      return;
    } else {
      try {
        if (file != null && file != undefined && file != "") {
          let form = new FormData();
          form.append("image", file);
          const response = await ApiService.postAPIWithAccessTokenMultiPart(
            api.chatImage,
            form
          );
          setFile(null);
          if (response.data.status) {
            const docid =
              sendInfo.senderId > userId
                ? userId + "-" + sendInfo.senderId
                : sendInfo.senderId + "-" + userId;
            const data = {
              text: message,
              image: response.data.data.imageUrl ?? "",
              sendBy: userId,
              sendto: sendInfo.senderId,
              username: sendInfo.name,
              userimage: sendInfo.image,
              user: {
                _id: userId,
              },
            };
            db.collection("provider_chats")
              .doc(docid)
              .collection("messages")
              .add({ ...data, createdAt: serverTimestamp() });
            setMessage("");
          } else {
            toast.error(response.data.message);
          }
        } else {
          const docid =
            sendInfo.senderId > userId
              ? userId + "-" + sendInfo.senderId
              : sendInfo.senderId + "-" + userId;
          const data = {
            text: message,
            image: "",
            sendBy: userId,
            sendto: sendInfo.senderId,
            username: sendInfo.name,
            userimage: sendInfo.image,
            user: {
              _id: userId,
            },
          };
          db.collection("provider_chats")
            .doc(docid)
            .collection("messages")
            .add({ ...data, createdAt: serverTimestamp() });
          setMessage("");
        }
      } catch (error) {
        // console.log("Error in send message function :- ", error);
      }
    }
  };

  const handleFilter = (e) => {
    e.persist();
    let name = "";
    let status = "";
    if (e.target.name === "name") name = e.target.value;
    if (e.target.name === "status") status = e.target.value;
    bookingList(
      api.bookingList +
        `?providerid=${sendInfo.senderId}&search=${name}&status=${status}`
    );
  };

  const getMyProfile = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log(response.data.data);
    if (response.data.status && response.data.statusCode === 200) {
      setMyDetails(response.data.data);
    } else setMyDetails();
    setLoading(false);
  };

  const completeJob = async (id, userId, providerId) => {
    setLoading(true);
    let form = JSON.stringify({
      status: 4,
      userid: userId,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.serviceRequest + `${id}`,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      setRatingModal({ status: true, id: id, provider_id: providerId });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const submitRating = async (formValue) => {
    setLoading(true);
    let form = JSON.stringify({
      care_provider_id: ratingModal.provider_id,
      object_id: ratingModal.id,
      object_type: "PROVIDER",
      rating: formValue.rating,
      review: formValue.review,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.submitRating,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      navigate(routes.myJobs, {
        state: {
          tab: 4,
        },
      });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const getCreatedList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    if (response.data.status && response.data.statusCode === 200) {
      setShareList(response.data.data.communityList);
    } else setShareList([]);
    setLoading(false);
  };

  useEffect(() => {
    getProviders(api.providerChatList);
    getMyProfile(api.profile);
    getCreatedList(api.shareCommunityList);
  }, []);

  useEffect(() => {
    if (sendInfo.senderId) {
      // const docid = userId + "-" + sendInfo.senderId;
      const docid =
        sendInfo.senderId > userId
          ? userId + "-" + sendInfo.senderId
          : sendInfo.senderId + "-" + userId;

      const getMessage = db
        .collection("provider_chats")
        .doc(docid)
        .collection("messages")
        .orderBy("createdAt", "asc");

      const allMessgae = getMessage.onSnapshot((ele) => {
        setMessagesData(
          ele.docs.map((doc) => ({
            data: doc.data(),
          }))
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendInfo, message]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messagesData]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="messages-section">
          <div className="row">
            <div className="col-md-4">
              <div className="chat-userlist-sidebar">
                <div className="chat-userlist-sidebar-head">
                  <div className="chat-panel-sidebar-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      {" "}
                      <path
                        d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                        stroke="#4F5168"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M22 12.86C22 15.15 20.82 17.18 19 18.46L17.66 21.41C17.35 22.08 16.45 22.21 15.98 21.64L14.5 19.86C12.08 19.86 9.92001 18.79 8.57001 17.12L9.5 16C13.64 16 17 12.87 17 9C17 7.95 16.75 6.96001 16.3 6.07001C19.57 6.82001 22 9.57999 22 12.86Z"
                        stroke="#4F5168"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                      <path
                        d="M7 9H12"
                        stroke="#7BC043"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>{" "}
                    </svg>
                  </div>
                  <h2>
                    New Messages
                    {/* <span>08 New</span> */}
                  </h2>
                </div>
                <div className="chat-userlist-sidebar-body">
                  <div className="chat-userlist-filter">
                    <input
                      type="text"
                      name=""
                      className="form-control"
                      id="searchInput"
                      placeholder="Search by Name"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                      className="search-btn"
                      type="button"
                      onClick={() =>
                        getProviders(api.providerChatList + `?search=${search}`)
                      }
                    >
                      <img src={SearchImg} />
                    </button>
                    <button
                      className="search-btn"
                      type="button"
                      onClick={() => {
                        getProviders(api.providerChatList);
                        document.getElementById("searchInput").value = "";
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.55 21.67C18.84 20.54 22 16.64 22 12C22 6.48 17.56 2 12 2C5.33 2 2 7.56 2 7.56M2 7.56V3M2 7.56H4.01H6.44"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 12C2 17.52 6.48 22 12 22"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-dasharray="3 3"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="chat-userlist-info">
                    {providers.length !== 0 ? (
                      providers.map((ele, indx) => {
                        return (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              createGroup(
                                ele.userid,
                                ele.id,
                                ele?.business_name
                                  ? ele?.business_name
                                  : ele?.fullname,
                                ele.logo !== null &&
                                  ele.logo !== "" &&
                                  ele.logo !== undefined
                                  ? ele.logo
                                  : ele.profile_image
                              )
                            }
                            key={indx}
                            className={
                              sendInfo.senderId === ele.id
                                ? "chat-userlist-item active"
                                : "chat-userlist-item"
                            }
                          >
                            <Link to="">
                              <div className="chat-userlist-item-image">
                                {ele.logo !== null &&
                                ele.logo !== "" &&
                                ele.logo !== undefined ? (
                                  <img src={ele.logo} alt="" className="me-3" />
                                ) : ele.profile_image === null ||
                                  ele.profile_image === "" ||
                                  ele.profile_image === undefined ? (
                                  <img src={NoImage} alt="" className="me-3" />
                                ) : (
                                  <img
                                    src={ele.profile_image}
                                    alt=""
                                    className="me-3"
                                  />
                                )}
                                {/* <span className="user-status"></span> */}
                              </div>
                            </Link>
                            <div className="chat-userlist-item-content">
                              <h4>
                                {ele?.business_name
                                  ? ele?.business_name
                                  : ele?.fullname}
                              </h4>
                              <p>{ele.email ?? "NA"}</p>
                            </div>
                            {/* <div className="chat-userlist-item-content">
                                <div className="chat-userlist-time">02:50 PM</div>
                                <div className="unread-message">
                                  <span className="badge">02</span>
                                </div>
                              </div> */}
                          </div>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "5% 0",
                        }}
                      >
                        <img width={300} src={NoData} alt="" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              {sendInfo.senderId && (
                <>
                  <div className="messages-tab">
                    <ul className="nav nav-tabs">
                      <li>
                        <Link
                          className={status === 0 ? "active" : ""}
                          onClick={() => {
                            setStatus(0);
                            bookingList(
                              api.bookingList +
                                `?providerid=${sendInfo.senderId}`
                            );
                            setFile(null);
                          }}
                          to=""
                          data-bs-toggle="tab"
                        >
                          Chat
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={status === 1 ? "active" : ""}
                          onClick={() => {
                            setStatus(1);
                            bookingList(
                              api.bookingList +
                                `?providerid=${sendInfo.senderId}`
                            );
                            setFile(null);
                          }}
                          to=""
                          data-bs-toggle="tab"
                        >
                          Provider Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className={status === 2 ? "active" : ""}
                          onClick={() => {
                            setStatus(2);
                            bookingList(
                              api.bookingList +
                                `?providerid=${sendInfo.senderId}`
                            );
                            setFile(null);
                          }}
                          to=""
                          data-bs-toggle="tab"
                        >
                          Booking
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="messages-tabs-content-info tab-content">
                    {status === 0 ? (
                      <div className="tab-pane active" id="Chat">
                        <div className="chat-panel-section">
                          <div className="chat-panel-chat-header">
                            <div className="chat-panel-user-item">
                              <div className="chat-panel-user-item-image">
                                {sendInfo.image !== null &&
                                sendInfo.image !== "" &&
                                sendInfo.image !== undefined ? (
                                  <img src={sendInfo.image} />
                                ) : (
                                  <img src={NoImage} alt="" />
                                )}
                              </div>
                              <div className="chat-panel-user-item-text">
                                <h4>{sendInfo.name ?? "NA"}</h4>
                                <p>Emp Id: {sendInfo.userId ?? "NA"}</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="chat-panel-chat-body"
                            tabindex="1"
                            style={{ overflow: "auto", outline: "none" }}
                          >
                            <div className="chat-panel-chat-content">
                              <div className="messages-list">
                                {messagesData.length !== 0 ? (
                                  messagesData.map(({ data }, i) => {
                                    return (
                                      <div
                                        key={i}
                                        className={
                                          parseInt(data.sendBy) === userId
                                            ? "message-item outgoing-message"
                                            : "message-item"
                                        }
                                      >
                                        <div className="message-item-chat-card">
                                          <div className="message-item-user">
                                            {parseInt(data.sendBy) ===
                                            userId ? (
                                              myDetails?.logo !== null &&
                                              myDetails?.logo !== "" &&
                                              myDetails?.logo !== undefined ? (
                                                <img
                                                  src={myDetails?.logo}
                                                  alt=""
                                                />
                                              ) : myDetails?.image === null ||
                                                myDetails?.image === "" ||
                                                myDetails?.image ===
                                                  undefined ? (
                                                <img src={NoImage} alt="" />
                                              ) : (
                                                <img
                                                  src={myDetails?.image}
                                                  alt=""
                                                />
                                              )
                                            ) : sendInfo.image !== null &&
                                              sendInfo.image !== "" &&
                                              sendInfo.image !== undefined ? (
                                              <img src={sendInfo.image} />
                                            ) : (
                                              <img src={NoImage} alt="" />
                                            )}
                                          </div>
                                          <div className="message-item-chat-content">
                                            <div className="message-content">
                                              {data?.image !== null &&
                                              data?.image !== "" &&
                                              data?.image !== undefined ? (
                                                <div>
                                                  <img
                                                    width={150}
                                                    height={90}
                                                    style={{
                                                      objectFit: "cover",
                                                      objectPosition: "center",
                                                      borderRadius: "5px",
                                                    }}
                                                    src={data.image}
                                                    alt=""
                                                  />
                                                </div>
                                              ) : null}
                                              <div className="mt-1">
                                                {data.text}
                                              </div>
                                            </div>
                                            <div className="time">
                                              {moment(
                                                convertTime(data.createdAt)
                                              ).format("h:mm A | DD MMM YYYY")}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="d-flex justify-content-center align-items-center mt-5 w-100">
                                    <h5 className="mt-5">No messages found</h5>
                                  </div>
                                )}
                              </div>
                              <div ref={bottomRef} />
                            </div>
                          </div>
                          <div className="chat-panel-chat-footer pb-0">
                            <div className="form">
                              {file != "" &&
                              file != null &&
                              file != undefined ? (
                                <div
                                  className="upload-signature mb-2"
                                  style={{ width: "82.5%" }}
                                >
                                  <label for="files">
                                    <div className="signature-text">
                                      <span>
                                        <img src={uploadImage} alt="" />
                                        <small className="prev-filename">
                                          {file.name}
                                        </small>
                                      </span>
                                    </div>
                                  </label>
                                </div>
                              ) : null}
                              <div className="row">
                                <div className="col-md-10">
                                  <div className="form-group mb-0">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      value={message ?? ""}
                                      className="form-control"
                                      id="exampleFormControlInput2"
                                      placeholder={
                                        file != "" &&
                                        file != null &&
                                        file != undefined
                                          ? "Add a caption"
                                          : `Message ${sendInfo.name ?? ""}`
                                      }
                                      onKeyDown={handleKey}
                                      onChange={(e) =>
                                        setMessage(e.target.value)
                                      }
                                    />
                                    <span
                                      className="form-attachemnt-icon"
                                      onClick={handleIconClick}
                                    >
                                      <img src={AttachImg} />
                                    </span>
                                    <input
                                      type="file"
                                      ref={fileInputRef}
                                      accept="images/*"
                                      style={{ display: "none" }}
                                      onChange={handleFileChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <button
                                    className="btn-send"
                                    title=""
                                    type="button"
                                    onClick={() => sendMessage()}
                                  >
                                    Send
                                  </button>
                                </div>
                                <div className="col-md-12">
                                  <p
                                    className="text-danger mt-3"
                                    style={{ fontSize: "0.8rem" }}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                        stroke="#292D32"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12 8V13"
                                        stroke="red"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M11.9946 16H12.0036"
                                        stroke="red"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    &nbsp; You can confirm the care job by
                                    navigating to the Booking tab and clicking
                                    on the confirmation option.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : status === 1 ? (
                      <div className="tab-pane" id="ProviderProfile">
                        <div className="providerProfile-section">
                          <div className="user-table-item">
                            <div className="row g-1 align-items-center">
                              <div className="col-md-8">
                                <div className="user-profile-item">
                                  <div className="user-profile-media">
                                    {details?.logo !== null &&
                                    details?.logo !== "" &&
                                    details?.logo !== undefined ? (
                                      <img
                                        src={details?.logo}
                                        alt=""
                                        className="me-3"
                                      />
                                    ) : details?.profile_image === null ||
                                      details?.profile_image === "" ||
                                      details?.profile_image === undefined ? (
                                      <img
                                        src={NoImage}
                                        alt=""
                                        className="me-3"
                                      />
                                    ) : (
                                      <img
                                        src={details?.profile_image}
                                        alt=""
                                        className="me-3"
                                      />
                                    )}
                                  </div>
                                  <div className="user-profile-text">
                                    <h2>
                                      {details?.business_name
                                        ? details?.business_name
                                        : details?.fullname}
                                    </h2>
                                    <div className="location-text">
                                      {details?.business_address ?? "NA"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="row g-1 align-items-center">
                                  <div className="col-md-6">
                                    <div className="user-contact-info">
                                      <div className="user-contact-info-icon">
                                        <img src={StarImg} />
                                      </div>
                                      <div className="user-contact-info-content">
                                        <h2>Rating</h2>
                                        <p>
                                          {details?.avarageRating
                                            ?.average_rating ?? "0"}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="col-md-4">
                                    <div className="user-contact-info">
                                      <div className="user-contact-info-icon">
                                        <img src={DollarImg} />
                                      </div>
                                      <div className="user-contact-info-content">
                                        <h2>Rate</h2>
                                        <p>{details?.fee ?? "NA"}</p>
                                      </div>
                                    </div>
                                  </div> */}

                                  <div className="col-md-6">
                                    <div className="user-contact-info">
                                      <div className="user-contact-info-icon">
                                        <img src={BreifImg} />
                                      </div>
                                      <div className="user-contact-info-content">
                                        <h2>Experience</h2>
                                        <p>{details?.experience ?? 0} Years</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="providerProfile-point">
                              <div className="providerprofile-point-item">
                                <img src={HouseImg} /> Cared{" "}
                                {details?.caredFamilys ?? 0} Families
                              </div>
                              <div className="providerprofile-point-item">
                                <img src={HandImg} /> Hired By{" "}
                                {details?.caredFamilyNearBy ?? 0} Families In
                                Your Neighbourhood
                              </div>
                              <div className="providerprofile-point-item">
                                <button
                                  className="btn-gr mt-2"
                                  type="button"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (shareList.length !== 0) {
                                      navigate(routes.communityShareProfile, {
                                        state: {
                                          id: encode(details?.userid),
                                        },
                                      });
                                    } else {
                                      toast.error("No communities found");
                                    }
                                  }}
                                >
                                  Share
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="providerprofile-overview">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="overview-card">
                                  <div className="overview-content">
                                    <h2>Repeat Clients</h2>
                                    <h4>{details?.repeatClient ?? "0"}</h4>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="overview-card">
                                  <div className="overview-content">
                                    <h2>Response Rate</h2>
                                    <h4>{details?.responseRate ?? "NA"}</h4>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-4">
                                <div className="overview-card">
                                  <div className="overview-content">
                                    <h2>Response Time</h2>
                                    <h4>{details?.responseTime ?? "NA"}</h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="providerprofile-about">
                            <h2>About </h2>
                            <p>{details?.description ?? "NA"}</p>
                          </div>

                          <div className="providerprofile-about">
                            <h2>Offering Services</h2>
                            <div>
                              <div className="tags-item">
                                {details?.category ?? "NA"}
                              </div>
                              <div className="tags-item-sub">
                                {details?.subcategory ?? "NA"}
                              </div>
                            </div>
                          </div>

                          <div class="review-card mt-3">
                            <div class="review-card-content">
                              <div class="review-card-icon">
                                <img src={StarWhImg} />
                              </div>
                              <div class="review-card-text">
                                <h3>Rating & Review</h3>
                                <p>
                                  {details?.avarageRating?.average_rating ?? 0}(
                                  {details?.avarageRating?.total_reviews ?? 0})
                                </p>
                              </div>
                            </div>
                            {/* <div class="review-card-action">
                    <link to="">Write your Review</link>
                  </div> */}
                          </div>
                          <div class="care-comment-list">
                            {details?.reviewsList.length !== 0
                              ? details?.reviewsList.map((ele, indx) => {
                                  return (
                                    <div key={indx} class="care-comment-item">
                                      <div class="care-comment-profile">
                                        {ele?.image !== null &&
                                        ele?.image !== "" &&
                                        ele?.image !== undefined ? (
                                          <img src={ele?.image} alt="" />
                                        ) : (
                                          <img src={NoImage} alt="" />
                                        )}
                                      </div>
                                      <div class="care-comment-content">
                                        <div class="care-comment-head">
                                          <div class="">
                                            <h2>{ele?.fullname ?? "NA"}</h2>
                                            <div class="care-comment-rating">
                                              <i class="fa fa-star"></i>{" "}
                                              {ele?.rating ?? 0}
                                            </div>
                                          </div>
                                          <div class="care-date">
                                            <i class="fa fa-calendar"></i>{" "}
                                            {moment(ele?.modified_date).format(
                                              "MM-DD-yyyy hh:mm A"
                                            )}
                                          </div>
                                        </div>
                                        <div class="care-comment-descr">
                                          {ele?.review ?? "NA"}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })
                              : null}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="tab-pane" id="Booking">
                        <div className="care-title-header">
                          <h2 className="heading-title">Booking</h2>
                          <div className="search-filter wd60">
                            <div className="row g-2">
                              <div className="col-md-5">
                                <div className="form-group">
                                  <div className="search-form-group">
                                    <select
                                      name="status"
                                      onChange={(e) => handleFilter(e)}
                                      id=""
                                      className="form-control"
                                    >
                                      <option value="">Select Status</option>
                                      <option value="1">Pending</option>
                                      <option value="2">Ongoing</option>
                                      <option value="3">Cancelled</option>
                                      <option value="4">Completed</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-7">
                                <div className="form-group">
                                  <div className="search-form-group">
                                    <input
                                      type="text"
                                      name="name"
                                      className="form-control"
                                      placeholder="Search "
                                      onChange={(e) => handleFilter(e)}
                                    />
                                    <span className="search-icon">
                                      <img src={Search} />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ProviderProfile-section">
                          {list.length !== 0 ? (
                            list.map((ele, indx) => {
                              return (
                                <div key={indx} className="care-card">
                                  <div className="care-card-head">
                                    <div className="care-id">
                                      Job ID: <span>{ele.job_id ?? "NA"}</span>
                                    </div>

                                    {ele.request_status == 1 ? (
                                      <div>
                                        <Link
                                          className="btn-gr"
                                          to=""
                                          onClick={() =>
                                            setBookingStatus({
                                              open: true,
                                              status: 2,
                                              id: ele.id,
                                              providerUserId:
                                                ele.provider_userid,
                                            })
                                          }
                                        >
                                          Confirm
                                        </Link>
                                        <Link
                                          className="btn-re mx-2"
                                          to=""
                                          onClick={() =>
                                            setBookingStatus({
                                              open: true,
                                              status: 3,
                                              id: ele.id,
                                              providerUserId:
                                                ele.provider_userid,
                                            })
                                          }
                                        >
                                          Reject
                                        </Link>
                                      </div>
                                    ) : ele.request_status == 2 ? (
                                      <Link
                                        className="btn-gr"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          completeJob(
                                            ele?.id,
                                            ele?.provider_userid,
                                            ele?.provider_id
                                          );
                                        }}
                                      >
                                        Mark As Complete
                                      </Link>
                                    ) : (
                                      <div className="care-status text-capitalize">
                                        Status:{" "}
                                        <span
                                          className={
                                            ele.request_status_text == "Pending"
                                              ? "text-warning"
                                              : ele.request_status_text ==
                                                  "Completed" ||
                                                ele.request_status_text ==
                                                  "Ongoing"
                                              ? "text-success"
                                              : "text-danger"
                                          }
                                        >
                                          {ele.request_status_text ?? "NA"}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="care-card-body">
                                    <div className="care-content">
                                      <div className="title-text">
                                        {ele.first_name ?? "NA"}
                                      </div>
                                      <div className="row d-flex justify-content-between w-100">
                                        <div className="col-md-8">
                                          <div className="date-text">
                                            <img src={WhCalen} />{" "}
                                            {moment(ele.start_date).format(
                                              "MM-DD-yyyy"
                                            )}{" "}
                                            {ele.start_time ?? "NA"}
                                          </div>
                                        </div>
                                        <div className="col-md-4 mt-2">
                                          <div className="tags-list float-end">
                                            <div className="tags-item-sub">
                                              {ele?.gender == "M"
                                                ? "Male"
                                                : "Female"}
                                            </div>
                                            <div className="tags-item-sub mx-2">
                                              Age of who needs care: {ele?.age ?? "NA"} Years
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row d-flex justify-content-between w-100">
                                        <div className="col-md-12 d-flex justify-content-between">
                                          <div className="jobs-details-point-item">
                                            <h4>Prefered Contact: </h4>
                                            <p className="text-capitalize">
                                              {ele.prefer_contacted ?? "NA"}
                                            </p>
                                          </div>
                                          <div className="jobs-details-point-item">
                                            <h4>Best Time To Call: </h4>
                                            <p className="text-capitalize">
                                              {ele.best_time_to_call ?? "NA"}
                                            </p>
                                          </div>
                                          <div className="jobs-details-point-item">
                                            <h4>Your Relationship To Who Needs Care: </h4>
                                            <p>{ele.relationship ?? "NA"}</p>
                                          </div>
                                          <div className="jobs-details-point-item">
                                            <h4>Payment Type: </h4>
                                            <p>{ele.payment_type ?? "NA"}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="care-day-Weekly-info mt-3">
                                      <div className="row w-100">
                                        <div className="col-md-3">
                                          <div className="care-point-box">
                                            <div className="care-point-icon">
                                              <img src={RepeatImg} />
                                            </div>
                                            <div className="care-point-text">
                                              <h4>Frequency:</h4>
                                              <p
                                                className="text-capitalize"
                                                style={{ height: "25px" }}
                                              >
                                                {ele.frequency === "O"
                                                  ? "One Time"
                                                  : ele.frequency === "W"
                                                  ? "Repeat Weekly"
                                                  : "Repeat Monthly"}
                                              </p>
                                              <div className="care-day-list">
                                                {ele.days !== null &&
                                                ele.days !== "" &&
                                                ele.days !== undefined
                                                  ? JSON.parse(ele.days).map(
                                                      (element, index) => {
                                                        return (
                                                          <div
                                                            key={index}
                                                            className="tags-item-sub me-1"
                                                          >
                                                            {weekDays(element)}
                                                          </div>
                                                        );
                                                      }
                                                    )
                                                  : null}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-9">
                                          <div className="care-point-box">
                                            <div className="care-point-icon">
                                              <img src={locationImage} />
                                            </div>
                                            <div className="care-point-text">
                                              <h4>Address of Client or Person That Needs Care:</h4>
                                              <p>{ele.address ?? "NA"}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="care-day-list">
                                        {/* <div className="care-day-item">S</div>
                                        <div className="care-day-item">T</div>
                                        <div className="care-day-item">W</div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "5% 0",
                              }}
                            >
                              <img width={300} src={NoData} alt="" />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={bookingStatus.open}
        onHide={() => {
          setBookingStatus({
            open: false,
            status: null,
            id: null,
            providerUserId: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text my-4">
                <h5 className="text-center pb-0">Change Booking Status</h5>
                <p className="text-center">
                  Do you really want to{" "}
                  {bookingStatus.status == 2 ? "confirm" : "reject"} this
                  booking ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() =>
                    setBookingStatus({
                      open: false,
                      status: null,
                      id: null,
                      providerUserId: null,
                    })
                  }
                  className="btn-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-gr"
                  data-bs-dismiss="modal"
                  onClick={() =>
                    bookingRequest(
                      bookingStatus.id,
                      bookingStatus.status,
                      bookingStatus.providerUserId
                    )
                  }
                >
                  Yes! {bookingStatus.status == 2 ? "Confirm" : "Reject"}
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={ratingModal.status}
        onHide={() => {
          setRatingModal({
            status: false,
            id: null,
            provider_id: null,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Give Feedback</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValuesRating}
                validateOnChange={true}
                validationSchema={validationSchemaRating}
                onSubmit={submitRating}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="form-group mb-4">
                      <h4>Rating</h4>
                      <div class="star-rating">
                        <Field
                          type="radio"
                          id="star5"
                          name="rating"
                          value="5"
                        />
                        <label for="star5">&#9733;</label>
                        <Field
                          type="radio"
                          id="star4"
                          name="rating"
                          value="4"
                        />
                        <label for="star4">&#9733;</label>
                        <Field
                          type="radio"
                          id="star3"
                          name="rating"
                          value="3"
                        />
                        <label for="star3">&#9733;</label>
                        <Field
                          type="radio"
                          id="star2"
                          name="rating"
                          value="2"
                        />
                        <label for="star2">&#9733;</label>
                        <Field
                          type="radio"
                          id="star1"
                          name="rating"
                          value="1"
                        />
                        <label for="star1">&#9733;</label>
                      </div>
                      <ErrorMessage
                        name="rating"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="mb-3">
                      <div className="form-group search-form-group mb-1">
                        <h4>What are the main reasons for your rating?</h4>
                        <Field
                          type="text"
                          as="textarea"
                          className="form-control"
                          name="review"
                          placeholder="Enter Message"
                          style={{ height: "150px" }}
                        />
                        {/* <span className="form-group-icon">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                              stroke="#292D32"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.9965 11H16.0054"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.9955 11H12.0045"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.99451 11H8.00349"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span> */}
                      </div>
                      <ErrorMessage
                        name="review"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setRatingModal({
                            status: false,
                            id: null,
                            provider_id: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
